import React, {useState} from "react";
import {Dialog} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";


const OfferModal = (props)=>{
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);

    const handleClickOpen = () => {
        setShow(true);
    };
    const modal= {
        position:"fixed",
        top:0,
        right:"auto",
        left:"auto",
        bottom:"0",
        height: '100%'
    };

    return(
        <div >
            <u style={{cursor:'pointer'}} onClick={handleClickOpen}>Details</u>
            <Dialog  style={modal}
                aria-labelledby="Tire Offer details"
                aria-describedby="Tire Offer details"
                open={show}
                onClose={handleClose}
                     fullScreen
            >
                <div className={'modal-header'}>
                    <div className="header-close" onClick={handleClose}>
                        <div className="header-close-icon icon close" />
                    </div>
                    <br/>
                </div>
                <Container maxWidth="lg">
                    <Typography variant="h2" gutterBottom>{props.headerInfo}</Typography>
                    <Typography variant="body1" gutterBottom>{props.offerBody}</Typography>
                    <Typography variant="body1" gutterBottom>{props.offerDisclaimer}</Typography>
                    <Typography variant="body1"
                                gutterBottom>{`Offer begins on ${props.effectiveDate} and ends on ${props.expirationDate}`}</Typography>
                </Container>
            </Dialog>
        </div>
    )
};

export default OfferModal
